module.exports = __webpack_public_path__ + "static/media/AUT.b2fe85a3.svg";